export default "__VITE_ASSET__35b1bccf__"